module.exports = __webpack_public_path__ + "img/brand-logo.58a224c0.png";